import { booleanAttribute, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CommonExplainModule } from '../../../common-explain/common-explain.module';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-searchable-entity',
  standalone: true,
  imports: [NgClass, CommonExplainModule, NgbTooltip],
  templateUrl: './searchable-entity.component.html',
  styleUrl: './searchable-entity.component.scss',
})
export class SearchableEntityComponent {
  @Input() entityName: string = '';
  @Input() entityNameHtml: string = '';
  @Input() baseUrl: string = '';
  @Input() attributeName: string = '';
  @Input() styleClass: 'regular' | 'light' | 'darkblue' | 'dark' = 'light';
  @Input({ transform: booleanAttribute }) newTab = true;
  @Input({ transform: booleanAttribute }) clickBlocked = false;

  onClick() {
    if (this.clickBlocked) return;
    window.open(`${this.baseUrl}?${this.attributeName}=${this.entityName}`, '_blank');
  }
}
